/**
 * Initial state
 */
const initialState = {
    submitting:false
};

/**
 * Statons reducer
 */
export default function (state = initialState, action) {
    switch (action.type) {

        case "CARS_RESET":
            return initialState;
        case "CARS_CREATE_INPROGRESS":
            return {
                ...state,
                submitting:true
            };
        case "CARS_CREATE_SUCCESS":
            return {
                ...state,
                submitting:false
            };
        case "CARS_CREATE_FAILURE":
            return {
                ...state,
                submitting:false
            };


        case "CARS_UPDATE_INPROGRESS":
            return {
                ...state,
                submitting:true
            };
        case "CARS_UPDATE_SUCCESS":
            return {
                ...state,
                submitting:false
            };
        case "CARS_UPDATE_FAILURE":
            return {
                ...state,
                submitting:false
            };


        default:
            return state;

    }
}









// WEBPACK FOOTER //
// ./src/reducers/cars.js